import React from "react";
import { Container, Row } from "react-bootstrap";
import SingleCard from "../stories/components/Card.js";
import Header from "../stories/components/Header.js";

import aboutUsThumbnail from "../assets/frontpage/om-statsforvalteren.png";
import aboutThumbnail from "../assets/frontpage/om-profilen.png";
import logoThumbnail from "../assets/frontpage/logo.png";
import colorThumbnail from "../assets/frontpage/farger.png";
import typographyThumbnail from "../assets/frontpage/typografi.png";
import languageThumbnail from "../assets/frontpage/språk.png"
import illustrationThumbnail from "../assets/frontpage/mønster.png"
import templateThumbnail from "../assets/frontpage/maler.png"
import photoArchiveThumbnail from "../assets/frontpage/fotoarkiv.png"
import componentsThumbnail from "../assets/frontpage/komponentbibliotek.png"



export default function Frontpage() {
  return (
    <>
      <Container className="mb-6">
        <Header
          title="Statsforvalterens profilhåndbok"
          lead="For trykk og digitale flater"
        />
        <Row>
          <SingleCard
            title="Om Statsforvalteren"
            url="/om-statsforvalteren"
            lead="Informasjon om Statsforvalterens samfunnsoppdrag og oppgaver."
            imgUrl={aboutUsThumbnail}
            imgAlt="Riksvåpenet på mørkeblå bakgrunn"
          />
          <SingleCard
            title="Om profilen"
            url="/om-profilen"
            lead="Bakgrunn for Statsforvalterens logo, mønster og grafiske profil."
            imgUrl={aboutThumbnail}
            imgAlt="Eksempel på statsforvalternes mønster"
          />
          <SingleCard
            title="Logo"
            url="/logo"
            lead="Nedlastbare filer av Statsforvalterens logoer."
            imgUrl={logoThumbnail}
            imgAlt="Statsforvalterens logo"
          />

          <SingleCard
            title="Farger"
            url="/farger"
            lead="Statsforvalterens hovedfarge er mørkeblå. I tillegg finnes det profilerende farger som skaper variasjon i uttrykket."
            imgUrl={colorThumbnail}
            imgAlt="Sektordiagram av farger"
          />

          <SingleCard
            title="Typografi"
            url="/typografi"
            lead="Statsforvalterens profilfont er Open Sans, og skal i hovedsak brukes på alt materiell."
            imgUrl={typographyThumbnail}
            imgAlt="Og-tegn på mørkeblå bakgrunn"
          />

          <SingleCard
            title="Språk"
            url="/språk"
            lead="Klarspråk er viktig for Statsforvalteren, og all tekst skal være tydelig og forståeligfor leserne."
            imgUrl={languageThumbnail}
            imgAlt="Snakkeboble over mørkeblå bakgrunn"
          />
          <SingleCard
            title="Mønster"
            url="/mønster"
            lead="Oversikt over mønstrene i Statsforvalterens grafiske profil. Mønstrene kan brukespå ulike måter for å illustrere budskap eller skape et grafisk uttrykk."
            imgUrl={illustrationThumbnail}
            imgAlt="Eksempel på statsforvalternes mønster"
          />
          <SingleCard
            title="Maler"
            url="/maler"
            lead="Beskrivelser av Statsforvalterens maler til digitalt og analogt materiell."
            imgUrl={templateThumbnail}
            imgAlt="Nummerert punktliste hvor første punkt er et hake-tegn"
          />
          <SingleCard
            title="Fotoarkiv"
            url="/fotoarkiv"
            lead="Lenke til Statsforvalterens felles fotoarkiv."
            imgUrl={photoArchiveThumbnail}
            imgAlt="Kvadrater stablet om hverandre"
          />
          <SingleCard
            title="Komponentbibliotek"
            url="/storybook"
            lead="Komponentbibliotek for utviklere som skal utarbeide nye digitale løsninger for Statsforvalteren."
            imgUrl={componentsThumbnail}
            imgAlt="Eksempel-komponent med en lagre-knapp og en avbryt-knapp"
          />
        </Row>
      </Container>
    </>
  );
}
